import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07c9f5e6"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c9f5e6')) {
      api.createRecord('07c9f5e6', component.options)
    } else {
      api.reload('07c9f5e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07c9f5e6", function () {
      api.rerender('07c9f5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nested/menu1/menu/index.vue"
export default component.exports